// asset.service.ts (Angular 19 compatible — removed @angular/http completely)

import { throwError, Subject, Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { AuthenticationService } from "../auth/authentication.service";
import { Router } from "@angular/router";
import * as _ from "lodash";
import moment from "moment-timezone";
import { UtilServiceService } from "./utilService/util-service.service";

@Injectable()
export class AssetService {
  refreshPhoto$: EventEmitter<{}>;
  public refreshContractList$: EventEmitter<any>;
  public refreshStockList$: EventEmitter<any>;
  public refreshContractItem$: EventEmitter<any>;
  public refreshMaintenanceList$: EventEmitter<any>;
  public refreshScheduledMaintenanceList$: EventEmitter<any>;
  public refreshAccessories$: EventEmitter<any>;

  public refreshAssetLogList$: EventEmitter<any>;
  public refreshConsignmentList$: EventEmitter<any>;
  public refreshConsignmentItemList$: EventEmitter<any>;
  public refreshRequisitionList$: EventEmitter<any>;
  public refreshRequisitionItemList$: EventEmitter<any>;
  public refreshButton$: EventEmitter<any>;

  public refresherAssetStatusList$: EventEmitter<any>;
  public refresherAssetTypeList$: EventEmitter<any>;
  //Eventemitter for asset category list
  public refreshAssetCategoryList$: EventEmitter<any>;
  //Eventemitter for asset sub category list
  public refreshAssetSubCategoryList$: EventEmitter<any>;

  public refreshComponentList$: EventEmitter<any>;

  //Event Emitters related to SETUP2
  public refresherCertTypeList$: EventEmitter<any>;
  public refresherInspectTypeList$: EventEmitter<any>;
  //
  private ENDPOINT_ASSET_BRANDS = "/asset-brands";
  private ENDPOINT_ASSET_BUILDING = "/asset-buildings"; // Not In Use(Checked On 7/oct/2024)
  private ENDPOINT_ASSET_FLOORS_BY_BUILDING = "/asset-floors-by-building/";
  private ENDPOINT_ASSET_ROOMS_BY_FLOOR = "/asset-rooms-by-floor/";
  private ENDPOINT_SAVE_ASSET_PUT = "/v4/assets";
  private ENDPOINT_SAVE_ASSET_POST = "/v4/assets";
  private ENDPOINT_EDIT_ASSET = "/v4/assets/";
  private ENDPOINT_DELETE_ASSET = "/assets/";
  private ENDPOINT_ASSETS_HISTORY_BY_ASSETS = "/assets-histories/by-assets/";
  private ENDPOINT_ASSETS_FILTER = "/v5/assets/filter";
  private ENDPOINT_ASSETS_TYPES = "/assets-types";
  private ENDPOINT_ASSETS_STATUSES = "/assets-statuses";
  private ENDPOINT_ATTACHMENTS_UPLOAD = "/attachments/upload?parentType=";
  private ENDPOINT_ATTACHMENTS_UPLOADV2 = "/v2/attachments/upload?parentType=";
  private ENDPOINT_GET_ALL_USERS = "/v4/get-all-users";
  private ENDPOINT_GET_ALL_SERVICE_ZONES = "/service-zones/pick-list";
  private ENDPOINT_ASSET_STATUS_UPDATE = "/assets/status";
  private ENDPOINT_ASSET_CATEGORIES = "/asset-categories";
  //Endpoint for Asset sub-categories
  private ENDPOINT_ASSET_SUB_CATEGORIES = "/asset-sub-categories";
  //Endpoint for asset upload and get attachments
  private ENDPOINT_GET_ATTACHMENTS_BY_PARENT = "/attachments/by-parent";
  private ENDPOINT_UPLOAD_ASSET_ATTACHMENTS =
    "/attachments/upload?parentType=ASSET_ATTACHMENT&parentId=";

  //stocks
  private ENDPOINT_SAVE_STOCK = "/stock-checks";
  private ENDPOINT_EDIT_GET_STOCK = "/stock-checks/"; //for edit,View
  private ENDPOINT_HISTORY_BY_STOCK = "/stock-histories/by-stock-check/"; //view asset list
  private ENDPOINT_ASSET_BY_SERIALNO = "/assets-by-serialNo/"; // Not In Use(Checked On 7/oct/2024)
  private ENDPOINT_STOCK_CHECK_FILTER = "/stock-checks/filter";

  //contracts
  private ENDPOINT_CONTRACTS_ASSETS = "/v4/contracts/filter";
  private ENDPOINT_CONTRACTS_SO =
    "/v2/sales-orders/pick-list/search?value&customerId=";
  private ENDPOINT_CONTRACTS_BY_ID = "/v4/contracts/";
  private ENDPOINT_CONTRACTS_DELETE = "/contracts/";
  private ENDPOINT_CONTRACTS_ASSETS_PICKLIST = "/v4/assets/pick-list";
  private ENDPOINT_CONTRACTS_BIN_PICKLIST =
    "/inventories/location/bin?assetsId=";
  private ENDPOINT_CONTRACTS_COMPONENTS_PICKLIST =
    "/v4/assets/components/pick-list?assetsId=";
  private ENDPOINT_CONTRACTS = "/v4/contracts";
  private ENDPOINT_CONTRACTS_ITEM_DELETE =
    "/contracts/remove/contract-item?contractItemId=";
  private ENDPOINT_CONTRACTS_ITEM_ADD = "/contracts/add/contract-item";
  private ENDPOINT_CONTRACTS_ITEM_BY_ID = "/contract-items/";
  private ENDPOINT_CONTRACTS_CANCEL = "/contracts/v2/cancel?contractId=";
  private ENDPOINT_CONTRACTS_BY_CUSTOMER_ID = "/v4/contacts";
  private ENDPOINT_ASSET_NAME_CODE_SERIALNO_PICKLIST = "/v4/assets/pick-list";

  private ENDPOINT_GET_CONTRACT_ASSETS_ITEMS = "/v4-1/contract-items/assets";

  //maintenance
  private ENDPOINT_MAINTENANCE_ASSETS = "/maintenances/assets";
  private ENDPOINT_CONTRACT_PICKLIST = "/v4/contracts/filter?assetsId=";
  private ENDPOINT_MAINTENANCE_UPDATE = "/maintenances";
  private ENDPOINT_MAINTENANCE_BY_ID = "/maintenances/";

  //Preventative maintenance
  private ENDPOINT_MAINTENANCE_ITEMS_MAINTENANCE =
    "/v4-1/maintenance-items/maintenance"; //get all maintenance items=> CS-4517
  private ENDPOINT_MAINTENANCE_ITEMS_ASSETS = "/v4-1/maintenance-items";
  private ENDPOINT_MAINTENANCE_PICKLIST = "/maintenances/pick-list";
  private ENDPOINT_MAINTENANCE_ITEMS = "/v4-1/maintenance-items";
  private ENDPOINT_MAINTENANCE_ITEMS_BY_ID = "/maintenance-items/";
  private ENDPOINT_JOBORDERS_PICKLIST = "/job-orders";
  private ENDPOINT_MAINTENANCE_BY_ASSETS =
    "/maintenances/assets-value?maintenanceId=";
  private ENDPOINT_MAINTENANCE_BY_ASSET_ID =
    "/maintenances/pick-list?assetsId=";

  //accessories
  private ENDPOINT_ACCESSORIES = "/asset-components";
  private ENDPOINT_ACCESSORIES_BY_ID = "/asset-components";
  private ENDPOINT_GET_ACCESORIES_BY_ASSETS_ID = "/v4/accessories";

  //Consignment
  private ENDPOINT_LIST_USERS = "/v4/get-all-users";
  private ENDPOINT_SAVE_CONSIGNMENT = "/consignment-notes";
  private ENDPOINT_GET_BY_ID_CONSIGNMENT = "/consignment-notes/";
  private ENDPOINT_CONSIGNMENT_ATTACHMENTS_UPLOAD =
    "/attachments/upload?parentType=CONSIGNMENT_NOTE_SIGNED_COPY&parentId=";
  private ENDPOINT_CONSIGNMENT_SENT_EMAIL = "/consignment-notes/email-to/";
  private ENDPOINT_CANCEL_CONSIGNMENT = "/consignment-notes/cancel/";
  private ENDPOINT_REJECT_CONSIGNMENT = "/consignment-notes/reject/";
  private ENDPOINT_APPROVE_CONSIGNMENT = "/consignment-notes/acknowledge/";

  //Consignment Items
  private ENDPOINT_LIST_CONSIGNMENT_ITEMS = "/consignment-items";
  private ENDPOINT_ITEM_BY_ID_CONSIGNMENT_ITEMS = "/consignment-items/";

  //Requisition
  private ENDPOINT_REQUISION_ATTACHMENTS_UPLOAD =
    "/attachments/upload?parentType=REQUISITION_NOTE_SIGNED_COPY&parentId=";
  private ENDPOINT_CANCEL_REQUISION = "/requisition-notes/cancel/";

  //contract accessories and assets
  private ENDPOINT_CONTRACT_ACCESSORIES = "/v4-1/contract-items/accessories";
  private ENDPOINT_CONTRACT_ASSETS = "/v4-1/contract-items/assets";

  private ENDPOINT_MAINTENANCE_FREQUENCY_PICKLIST =
    "/preventative-maintenance-frequencies/pick-list";

  private ENDPOINT_ASSET_METERS_UNITS_OF_MEASUREMENT =
    "/asset-meters-units-of-measurement";

  private ENDPOINT_ASSETS_SUMMERY = "/assets-summary/";
  private ENDPOINT_ASSETS_OVERVIEW = "/assets-overview";
  private ENDPOINT_ASSETS_TIMELINE = "/assets-audit-event-histories";
  private ENDPOINT_ASSETS_LOG = "/asset-logs";
  private ENDPOINT_ASSETS_LOG_MODIFIED_USERS = "/asset-logs/modified-users";
  private ENDPOINT_GET_ASSETS_ACCESORIES_BIN_DETAILS =
    "/inventories/location/bins";

  private assetItemsSource = new Subject<any>();
  assetitemsHandler = this.assetItemsSource.asObservable();

  private assetLogChangedSubject = new Subject<any>();
  isAssetLogDataChanged = this.assetLogChangedSubject.asObservable();

  //Overview panel inside asset details tab in asset detail page
  private ENDPOINT_ASSETS_DETAIL_OVERVIEW = "/assets/calculations/";

  //Asset Type related API (new version for SETUP2 addon)
  private ENDPOINT_ASSET_STATUSES_GROUP = "/assets-statuses-group";
  private ENDPOINT_ASSET_STATUSES = "/v2/assets-statuses";
  private ENDPOINT_ASSETS_STATUSES_NEW = "/v4/assets-statuses";
  private ENDPOINT_ASSETS = "/assets-types/all-info";
  private ENDPOINT_ASSETS_BY_TYPEID = "/asset-type-statuses-to-check";
  private ENDPOINT_ASSETS_STATUS_REORDER = "/assets-statuses/order-update";
  private ENDPOINT_ASSET_CERT_TYPES = "/asset-certification-types";
  private ENDPOINT_ASSET_INSPECT_TYPES = "/asset-inspection-types";
  private ENDPOINT_ASSET_CERT_RECORDS = "/asset-certification-records";
  private ENDPOINT_ASSET_INSPECT_RECORDS = "/asset-inspection-records";

  //endpoint for confirm update in asset component
  private ENDPOINT_VALIDATE_COMPONENT =
    "/assets/status/validate-component-cascade";

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService,
    private router: Router,
    private util: UtilServiceService,
  ) {
    this.refreshStockList$ = new EventEmitter();
    this.refreshContractItem$ = new EventEmitter();
    this.refreshPhoto$ = new EventEmitter();
    this.refreshContractList$ = new EventEmitter();
    this.refreshMaintenanceList$ = new EventEmitter();
    this.refreshScheduledMaintenanceList$ = new EventEmitter();
    this.refreshAccessories$ = new EventEmitter();
    this.refreshAssetLogList$ = new EventEmitter();
    this.refreshConsignmentList$ = new EventEmitter();
    this.refreshConsignmentItemList$ = new EventEmitter();
    this.refreshRequisitionList$ = new EventEmitter();
    this.refreshRequisitionItemList$ = new EventEmitter();
    this.refreshButton$ = new EventEmitter();

    this.refresherAssetStatusList$ = new EventEmitter();
    this.refresherAssetTypeList$ = new EventEmitter();
    this.refreshAssetCategoryList$ = new EventEmitter();
    this.refreshAssetSubCategoryList$ = new EventEmitter();
    this.refreshComponentList$ = new EventEmitter();

    this.refresherCertTypeList$ = new EventEmitter();
    this.refresherInspectTypeList$ = new EventEmitter();
  }

  /** Helper: build auth headers (don’t set Content-Type for FormData uploads). */
  private authHeaders(extra?: Record<string, string>): HttpHeaders {
    const token = this.auth.getToken?.() ?? "";
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      ...(extra ?? {}),
    });
  }

  setItems(items: any) {
    this.assetItemsSource.next(items);
  }

  OnAssetLogDataChanged(message: any) {
    this.assetLogChangedSubject.next(message);
  }

  /************************************************ Asset types dd ************************************************/
  public getTypes(active: any = null) {
    var active1 = "";
    if (active) {
      active1 = "?isActive=true";
    }
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSETS_TYPES + active1, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createType(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_ASSETS_TYPES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateType(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_ASSETS_TYPES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateAssetsStatus(
    statusId: any,
    assetId: any,
    updateChildAssetsStatus: any = null,
  ) {
    let childAssetsStatus = "";
    if (updateChildAssetsStatus)
      childAssetsStatus = "&updateChildAssetsStatus=" + updateChildAssetsStatus;

    // NOTE: original code passed {observe:'response'} as body. Keeping minimal behavior change:
    return this.http
      .put(
        environment.base_url +
          this.ENDPOINT_ASSET_STATUS_UPDATE +
          "?id=" +
          assetId +
          "&statusId=" +
          statusId +
          childAssetsStatus,
        null,
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getTypeById(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSETS_TYPES + "/" + id)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAssetsById(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_EDIT_ASSET + id)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAssetsLogById(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSETS_LOG + "/" + id)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteAssetType(id: any) {
    return this.http
      .delete(environment.base_url + this.ENDPOINT_ASSETS_TYPES + "/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refresherAssetTypeList$.emit("Deleted Type");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getServiceZones() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_GET_ALL_SERVICE_ZONES, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp.body),
        catchError((error) => throwError(() => error)),
      );
  }

  public getEquipmenntTypes() {
    return this.http
      .get(environment.base_url + "/assets/eqp-types", { observe: "response" })
      .pipe(
        map((resp: any) => resp.body),
        catchError((error) => throwError(() => error)),
      );
  }

  /************************************************ Asset statuses dd ************************************************************************/
  public getStatuses(active: any = null) {
    var active1 = "";
    if (active) {
      active1 = "?isActive=true";
    }
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSETS_STATUSES + active1, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createStatus(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_ASSETS_STATUSES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateStatus(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_ASSETS_STATUSES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getStatusById(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSETS_STATUSES + "/" + id)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteAssetStatus(id: any) {
    return this.http
      .delete(environment.base_url + this.ENDPOINT_ASSETS_STATUSES + "/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refresherAssetStatusList$.emit("Deleted Status");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getUsers() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_GET_ALL_USERS, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //magnum Dashboard - Workshop Spare Monitoring
  public getMagnumAllAssets(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    assetTypes: any | number | boolean,
    assetStatuses: any | number | boolean,
    fromDate: any | number | boolean,
    toDate: any | number | boolean,
    roleId: any | number | boolean,
    assetTypeNames: any | number | boolean,
    columnName: any | number | boolean,
    sortOrder: any | number | boolean,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (assetTypes) params = params.set("assetTypes", assetTypes);
    if (assetStatuses) params = params.set("assetStatuses", assetStatuses);
    if (fromDate !== "" && toDate !== "") {
      fromDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(fromDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      toDate = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(toDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      params = params
        .set("nextMaintenanceFromDateTime", fromDate)
        .set("nextMaintenanceToDateTime", toDate);
    }
    if (roleId) params = params.set("roleId", roleId);
    if (assetTypeNames) params = params.set("assetTypeNames", assetTypeNames);
    if (columnName) params = params.set("columnName", columnName);
    if (sortOrder) params = params.set("sortOrder", sortOrder);
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSETS_FILTER, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => (resp.status == 204 ? false : resp.body)),
        catchError((error) => throwError(() => error)),
      );
  }

  //stock check grid
  public getAllStockCheck(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    customerId: any | number | boolean,
    status: any | number | boolean,
    columnName: any | number | boolean,
    sortOrder: any | number | boolean,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (customerId) params = params.set("customerId", customerId);
    if (status) params = params.set("status", status);
    if (columnName) params = params.set("columnName", columnName);
    if (sortOrder) params = params.set("sortOrder", sortOrder);
    return this.http
      .get(environment.base_url + this.ENDPOINT_STOCK_CHECK_FILTER, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => (resp.status == 204 ? false : resp.body)),
        catchError((error) => throwError(() => error)),
      );
  }

  //from stock tab view to asset view // Not In Use(Checked On 7/oct/2024)
  public getAssetViewBySerialNo(serialNo: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSET_BY_SERIALNO + serialNo, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //view asset list
  public getHistoryByStock(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_HISTORY_BY_STOCK + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //brand dd
  public getBrands() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSET_BRANDS, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /** ✅ UPDATED (was @angular/http) */
  public uploadAttachment(parentType: any, formData: any, parentId?: any) {
    const headers = this.authHeaders(); // FormData => do NOT set Content-Type
    let url: string = "";
    if (parentType == "ASSET_CERTIFICATION") {
      url = environment.base_url + this.ENDPOINT_ATTACHMENTS_UPLOAD + parentType + "&parentId=" + parentId;
    } else {
      url = environment.base_url + this.ENDPOINT_ATTACHMENTS_UPLOAD + parentType;
    }
    return this.http.post(url, formData, { headers, observe: "response" }).pipe(
      map((resp: any) => resp),
      catchError((error) => throwError(() => error)),
    );
  }

  //buildings dd
  // Not In Use(Checked On 7/oct/2024)
  public getAssetBuilding(customerId: any | number | boolean) {
    let params = new HttpParams();
    if (customerId) params = params.set("customerId", customerId);
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSET_BUILDING, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //floor dd
  public getAssetFloorByBuilding(buildingId: any) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSET_FLOORS_BY_BUILDING +
          buildingId,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //room dd
  public getAssetRoomsByFloor(floorId: any) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_ASSET_ROOMS_BY_FLOOR + floorId,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //edit asset call
  public getEditObj(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_EDIT_ASSET + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //history call
  public getHistory(assetsId: any) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSETS_HISTORY_BY_ASSETS +
          assetsId,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //add save - stock
  public createStock(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_SAVE_STOCK, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshStockList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  //edit save - stock
  public editStock(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_SAVE_STOCK, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshStockList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  //edit stock data call
  public getEditStockObj(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_EDIT_GET_STOCK + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteStock(id: any) {
    return this.http
      .delete(environment.base_url + this.ENDPOINT_EDIT_GET_STOCK + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshStockList$.emit("Deleted Stock");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  //grid call(assets - view -Contracts)
  public getAssetContractGrid(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    assetsId: any | number | boolean,
    statuses: any | number | boolean,
    parameters: any,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (assetsId) params = params.set("assetsId", assetsId);
    if (statuses) params = params.set("statuses", statuses);

    params = params.set("origin", "asset");

    if (parameters)
      params = params
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);

    return this.http
      .get(environment.base_url + this.ENDPOINT_CONTRACTS_ASSETS, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /////////////////////////////////////////////////// contracts/////////////////////////////////
  //grid call(Contracts)
  public getContractGrid(
    startFrom: any,
    perPage: any,
    search: any,
    statuses: any,
    parameters: any,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (statuses) params = params.set("statuses", statuses);
    if (parameters)
      params = params
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    return this.http
      .get(environment.base_url + this.ENDPOINT_CONTRACTS_ASSETS, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getContractByCustomer(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    statuses: any | number | boolean,
    parameters: any,
    customerId: any | number | boolean,
  ) {
    let params = new HttpParams();
    params = params.set("customerId", customerId);
    params = params.set("origin", "customer");
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (statuses) params = params.set("statuses", statuses);

    if (parameters)
      params = params
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    return this.http
      .get(environment.base_url + "/v4/contracts/filter", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //SO dd
  public getSalesOrder(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_CONTRACTS_SO + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /*****************************************Get Contract ASSETS Items*********************************************************************/
  public getContractAssetsItems(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_GET_CONTRACT_ASSETS_ITEMS, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getViewContract(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_CONTRACTS_BY_ID + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAssetsPicklist() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_CONTRACTS_ASSETS_PICKLIST, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getBinPicklist(assetId: any) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_CONTRACTS_BIN_PICKLIST + assetId,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAccessoriesPicklist(assetId: any) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_CONTRACTS_COMPONENTS_PICKLIST +
          assetId,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getCustodians(id: any) {
    let params = new HttpParams();
    params = params.set("customerId", id);
    return this.http
      .get(environment.base_url + this.ENDPOINT_CONTRACTS_BY_CUSTOMER_ID, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createContract(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_CONTRACTS, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshContractList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public editContract(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_CONTRACTS, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshContractList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteContract(id: any) {
    return this.http
      .delete(environment.base_url + this.ENDPOINT_CONTRACTS_DELETE + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshContractList$.emit("Deleted Contract");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public cancelContract(body: any, contractId: any) {
    return this.http
      .put(
        environment.base_url + this.ENDPOINT_CONTRACTS_CANCEL + contractId,
        body,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshContractList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getBins() {
    return this.http
      .get(environment.base_url + "/bins/combination/pick-list", {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  ///////////////////////////////// contract Item tab///////////////////////////////////////////
  public deleteContractItem(id: any) {
    return this.http
      .put(
        environment.base_url + this.ENDPOINT_CONTRACTS_ITEM_DELETE + id,
        null,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshContractItem$.emit("Deleted Contract Item");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public createContractItem(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_CONTRACTS_ITEM_ADD, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshContractItem$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getContractItemById(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_CONTRACTS_ITEM_BY_ID + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAssetsSummeryById(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSETS_SUMMERY + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAssetsOverviewById(assetId: any, date: any) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSETS_OVERVIEW +
          "?assetsId=" +
          assetId +
          "&currentDateTime=" +
          date,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAssetsTimeLineById(assetId: any, status: any) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSETS_TIMELINE +
          "?assetsId=" +
          assetId +
          "&fieldName=" +
          status,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getDataByAsset(assetsId: any) {
    let params = new HttpParams();
    params = params.set("assetsId", assetsId);
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_ASSET_NAME_CODE_SERIALNO_PICKLIST,
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  ///////////////////////////////////////////////  Maintenance  //////////////////////////////////
  public getMaintenanceGrid(
    startFrom: any,
    perPage: any,
    search: any,
    assetsId: any,
    columnName: any,
    sortOrder: any,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (assetsId) params = params.set("assetsId", assetsId);
    if (columnName) params = params.set("columnName", columnName);
    if (sortOrder) params = params.set("sortOrder", sortOrder);
    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_ASSETS, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => (resp.status == 204 ? false : resp.body)),
        catchError((error) => throwError(() => error)),
      );
  }

  public getContractMaintenanceGrid(
    startFrom: any,
    perPage: any,
    search: any,
    contractId: any,
    columnName: any,
    sortOrder: any,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (contractId) params = params.set("contractId", contractId);
    if (columnName) params = params.set("columnName", columnName);
    if (sortOrder) params = params.set("sortOrder", sortOrder);
    return this.http
      .get(environment.base_url + "/contract-maintenances", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => (resp.status == 204 ? false : resp.body)),
        catchError((error) => throwError(() => error)),
      );
  }

  public getContractsDd(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_CONTRACT_PICKLIST + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => {
          console.log("errr", error);
          return throwError(() => error);
        }),
      );
  }

  public createMaintenance(body: any) {
    return this.http
      .post(environment.base_url + "/maintenances", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshMaintenanceList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public editMaintenance(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_MAINTENANCE_UPDATE, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshMaintenanceList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteMaintenance(id: any) {
    return this.http
      .delete(environment.base_url + this.ENDPOINT_MAINTENANCE_BY_ID + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshMaintenanceList$.emit("Deleted Maintenance");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getViewMaintenance(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_BY_ID + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /////////////////////////////////////////////// scheduled  Maintenance  //////////////////////////////////
  //inside maintenance view grid
  public getScheduledMaintenanceGrid(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    maintenanceId: any | number | boolean,
    statuses: any | number | boolean,
    types: any | number | boolean,
    JOtypes: any | number | boolean,
    fromDate: any | number | boolean,
    toDate: any | number | boolean,
    serviceZoneId: any | number | boolean,
    columnName: any | number | boolean,
    sortOrder: any | number | boolean,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (maintenanceId) params = params.set("maintenanceId", maintenanceId);
    if (statuses) params = params.set("statuses", statuses);
    if (types) params = params.set("types", types);
    if (JOtypes) params = params.set("jobOrderTypeIds", JOtypes);
    if (serviceZoneId) params = params.set("serviceZoneId", serviceZoneId);
    if (fromDate !== "" && toDate !== "") {
      fromDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(fromDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      toDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(toDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      params = params
        .set("fromScheduledDateTime", fromDate)
        .set("toScheduledDateTime", toDate);
    }
    if (columnName) params = params.set("columnName", columnName);
    if (sortOrder) params = params.set("sortOrder", sortOrder);
    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_ITEMS_ASSETS, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => (resp.status == 204 ? false : resp.body)),
        catchError((error) => throwError(() => error)),
      );
  }

  //magnum dashboard - PREVENTATIVE MAINTENANCE
  public getMagnumScheduledMaintenanceGridAll(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    statuses: any | number | boolean,
    types: any | number | boolean,
    fromDate: any | number | boolean,
    toDate: any | number | boolean,
    serviceZoneId: any | number | boolean,
    roleId: any | number | boolean,
    columnName: any | number | boolean,
    sortOrder: any | number | boolean,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (statuses) params = params.set("statuses", statuses);
    if (types) params = params.set("types", types);
    if (serviceZoneId) params = params.set("serviceZoneId", serviceZoneId);
    if (roleId) params = params.set("roleId", roleId);
    if (fromDate !== "" && toDate !== "") {
      toDate = toDate + "T15:59:00Z";
      params = params
        .set("fromScheduledDateTime", fromDate)
        .set("toScheduledDateTime", toDate);
    }
    if (columnName) params = params.set("columnName", columnName);
    if (sortOrder) params = params.set("sortOrder", sortOrder);
    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_ITEMS, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => (resp.status == 204 ? false : resp.body)),
        catchError((error) => throwError(() => error)),
      );
  }

  //outside grid
  public getScheduledMaintenanceGridAll(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    statuses: any | number | boolean,
    types: any | number | boolean,
    JOtypes: any | number | boolean,
    fromDate: any | number | boolean,
    toDate: any | number | boolean,
    serviceZoneId: any | number | boolean,
    columnName: any | number | boolean,
    sortOrder: any | number | boolean,
    isDynamic: boolean,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (statuses) params = params.set("statuses", statuses);

    params = params.set("origin", "maintenance");

    if (JOtypes && JOtypes !== null && JOtypes.length > 0)
      params = params.set("jobOrderTypeIds", JOtypes);
    if (types && types !== null && types.length > 0)
      params = params.set("types", types);

    if (serviceZoneId) params = params.set("serviceZoneId", serviceZoneId);
    if (fromDate !== "" && toDate !== "") {
      fromDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(fromDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      toDate = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(toDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      params = params
        .set("fromScheduledDateTime", fromDate)
        .set("toScheduledDateTime", toDate);
    }
    if (columnName) params = params.set("columnName", columnName);
    if (sortOrder) params = params.set("sortOrder", sortOrder);
    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_ITEMS, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => (resp.status == 204 ? false : resp.body)),
        catchError((error) => throwError(() => error)),
      );
  }

  //inside assets view grid
  public getScheduledMaintenanceGridAssets(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    assetsId: any | number | boolean,
    statuses: any | number | boolean,
    types: any | number | boolean,
    JOtypes: any | number | boolean,
    fromDate: any | number | boolean,
    toDate: any | number | boolean,
    serviceZoneId: any | number | boolean,
    columnName: any | number | boolean,
    sortOrder: any | number | boolean,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (assetsId) params = params.set("assetsId", assetsId);
    if (statuses) params = params.set("statuses", statuses);
    if (types) params = params.set("types", types);
    if (JOtypes) params = params.set("jobOrderTypeIds", JOtypes);
    if (serviceZoneId) params = params.set("serviceZoneId", serviceZoneId);
    if (fromDate !== "" && toDate !== "") {
      fromDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(fromDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      toDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(toDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      params = params
        .set("fromScheduledDateTime", fromDate)
        .set("toScheduledDateTime", toDate);
    }
    params = params.set("origin", "asset");
    if (columnName) params = params.set("columnName", columnName);
    if (sortOrder) params = params.set("sortOrder", sortOrder);
    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_ITEMS_ASSETS, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => (resp.status == 204 ? false : resp.body)),
        catchError((error) => throwError(() => error)),
      );
  }

  public getMaintenancePicklist() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_PICKLIST, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getMaintenanceByAssetIdPicklist(assetsId: any) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_MAINTENANCE_BY_ASSET_ID + assetsId,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getActiveUsers() {
    return this.http.get(environment.base_url + "/v4/users/active").pipe(
      map((resp: any) => resp),
      catchError((error) => throwError(() => error)),
    );
  }

  public createScheduledMaintenance(body: any) {
    return this.http
      .post(environment.base_url + "/maintenance-items", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshScheduledMaintenanceList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public editScheduledMaintenance(body: any) {
    return this.http
      .put(environment.base_url + "/maintenance-items", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshScheduledMaintenanceList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getViewScheduledMaintenance(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_ITEMS_BY_ID + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteScheduledMaintenance(id: any) {
    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_MAINTENANCE_ITEMS_BY_ID + id,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshScheduledMaintenanceList$.emit(
            "Deleted Preventative Maintenance",
          );
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getJOPicklist() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_JOBORDERS_PICKLIST, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getMaintenanceByAssets(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_MAINTENANCE_BY_ASSETS + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /////////////////////////////////////////////// accessories //////////////////////////////////
  //grid call(assets - view - accessories)
  public getAssetAccessoriesGrid(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    assetsId: any | number | boolean,
    statuses: any | number | boolean,
    parameters: any,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (assetsId) params = params.set("assetsId", assetsId);
    if (statuses) params = params.set("statuses", statuses);
    if (parameters)
      params = params
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    return this.http
      .get(environment.base_url + this.ENDPOINT_ACCESSORIES_BY_ID, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createAccessories(body: any) {
    return this.http
      .post(environment.base_url + "/asset-components", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshAccessories$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public editAccessories(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_ACCESSORIES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshAccessories$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAccessoriesById(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ACCESSORIES_BY_ID + "/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteAccessories(id: any) {
    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_ACCESSORIES_BY_ID + "/" + id,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshAccessories$.emit("Deleted Accessories");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  //**================================== Consignment  =========================*/
  public getAllConsignments(
    status: any,
    company: any,
    searchValue: any,
    isSearch: any,
    attentionToId: any,
    parameters: any,
  ) {
    let params = new HttpParams();
    if (status !== "" && status != null && status.status) {
      params = params.set("status", status.status);
    }
    if (status && status.isMyPending && status.isMyPending === true) {
      params = params.set("isMyPending", status.isMyPending);
    }
    if (company !== "" && company != null) {
      params = params.set("company", company);
    }
    if (searchValue !== "" && searchValue != null) {
      params = params.set("search", searchValue);
    }
    params = params.set("isSearch", isSearch);
    if (attentionToId !== "" && attentionToId != null) {
      params = params.set("attentionToId", attentionToId);
    }
    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "25")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }
    return this.http
      .get(`${environment.base_url}/consignment-notes/filter`, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAllUsers() {
    return this.http.get(environment.base_url + this.ENDPOINT_LIST_USERS).pipe(
      map((resp: any) => resp),
      catchError((error) => throwError(() => error)),
    );
  }

  public createConsignment(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_SAVE_CONSIGNMENT, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshConsignmentList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public editConsignment(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_SAVE_CONSIGNMENT, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshConsignmentList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getByIdConsignment(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_GET_BY_ID_CONSIGNMENT + id)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAccesoriesBinDetaisl(ids: any) {
    let params = new HttpParams();
    if (ids) params = params.set("assetsIds", ids);
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_GET_ASSETS_ACCESORIES_BIN_DETAILS,
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteConsignment(id: any) {
    return this.http
      .delete(environment.base_url + "/consignment-notes/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshConsignmentList$.emit("Deleted Consignment");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  /** ✅ UPDATED (was @angular/http + ResponseContentType.Blob) */
  public generateConsignmentPDF(id: any) {
    const headers = this.authHeaders({ Accept: "application/pdf" });
    const formData = new FormData();
    return this.http
      .put(
        environment.base_url + "/consignment-notes/download-pdf/" + id,
        formData,
        {
          headers,
          responseType: "blob",
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshConsignmentList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  /** ✅ UPDATED (was @angular/http) */
  public uploadConsignmentAttachment(parentId: any, formData: any) {
    const headers = this.authHeaders(); // FormData => no Content-Type
    return this.http
      .post(
        environment.base_url +
          this.ENDPOINT_CONSIGNMENT_ATTACHMENTS_UPLOAD +
          parentId,
        formData,
        { headers, observe: "response" },
      )
      .pipe(
        map((resp: any) => {
          this.refreshPhoto$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getSentEmail(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_CONSIGNMENT_SENT_EMAIL + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public cancelConsignment(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_CANCEL_CONSIGNMENT + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshConsignmentList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public rejectConsignment(id: any, comment: any) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_REJECT_CONSIGNMENT +
          id +
          "?comment=" +
          comment,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => {
          this.refreshConsignmentList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public approveConsignment(id: any, comment: any) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_APPROVE_CONSIGNMENT +
          id +
          "?comment=" +
          comment,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => {
          this.refreshConsignmentList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  //**================================== Consignment  Items =========================*/
  public getAllConsignmentItems(id: any) {
    return this.http
      .get(
        environment.base_url + "/consignment-items/by-consignment-note/" + id,
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createConsignmentItem(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_LIST_CONSIGNMENT_ITEMS, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshConsignmentItemList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public editConsignmentItem(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_LIST_CONSIGNMENT_ITEMS, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshConsignmentItemList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getConsignmentItemById(id: any) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_ITEM_BY_ID_CONSIGNMENT_ITEMS + id,
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteConsignmentItem(id: any) {
    return this.http
      .delete(environment.base_url + "/consignment-items/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshConsignmentItemList$.emit("Deleted Consignment Item");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  //**================================== Requisition =========================*/
  public getAllRequisition(
    status: any,
    company: any,
    searchValue: any,
    isSearch: any | number | boolean,
    approvedByUserId: any,
    hodApprovedByUserId: any,
    parameters: any,
  ) {
    let params = new HttpParams();
    if (status !== "" && status != null) {
      params = params.set("status", status);
    }
    if (company !== "" && company != null) {
      params = params.set("company", company);
    }
    if (searchValue !== "" && searchValue != null) {
      params = params.set("search", searchValue);
    }
    params = params.set("isSearch", isSearch);
    if (approvedByUserId !== "" && approvedByUserId != null) {
      params = params.set("approvedByUserId", approvedByUserId);
    }
    if (hodApprovedByUserId !== "" && hodApprovedByUserId != null) {
      params = params.set("hodApprovedByUserId", hodApprovedByUserId);
    }
    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "25")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }
    return this.http
      .get(`${environment.base_url}/requisition-notes/filter`, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createRequisition(body: any) {
    return this.http
      .post(environment.base_url + "/requisition-notes", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public editRequisition(body: any) {
    return this.http
      .put(environment.base_url + "/requisition-notes", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getByIdRequisition(id: any) {
    return this.http
      .get(environment.base_url + "/requisition-notes/" + id)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteRequisition(id: any) {
    return this.http
      .delete(environment.base_url + "/requisition-notes/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit("Deleted Requisition");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  /** ✅ UPDATED (was @angular/http) */
  public uploadRequisitionAttachment(parentId: any, formData: any) {
    const headers = this.authHeaders(); // FormData => no Content-Type
    return this.http
      .post(
        environment.base_url +
          this.ENDPOINT_REQUISION_ATTACHMENTS_UPLOAD +
          parentId,
        formData,
        {
          headers,
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshPhoto$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getVerifiedApprove(
    id: any,
    comment: any,
    submitToHod: any,
    picToNotify: any,
  ) {
    return this.http
      .get(
        environment.base_url +
          "/requisition-notes/approve-verification/" +
          id +
          "?comment=" +
          comment +
          "&submitToHod=" +
          submitToHod +
          "&picId=" +
          picToNotify,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getVerifiedReject(id: any, comment: any, submitToHod: any) {
    return this.http
      .get(
        environment.base_url +
          "/requisition-notes/reject-verification/" +
          id +
          "?comment=" +
          comment +
          "&submitToHod=" +
          submitToHod,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getHODApprove(id: any, comment: any) {
    return this.http
      .get(
        environment.base_url +
          "/requisition-notes/approve-hod-verification/" +
          id +
          "?comment=" +
          comment,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getHODReject(id: any, comment: any) {
    return this.http
      .get(
        environment.base_url +
          "/requisition-notes/reject-hod-verification/" +
          id +
          "?comment=" +
          comment,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getSubmitForVerification(id: any) {
    return this.http
      .get(
        environment.base_url +
          "/requisition-notes/submit-for-verification/" +
          id,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  /** FIXED headers usage (HttpHeaders is immutable) */
  public generateRequisitionPDF(id: any) {
    const formData = new FormData();
    const headers = this.authHeaders({ Accept: "application/pdf" });

    return this.http
      .put(
        environment.base_url + "/requisition-notes/download-pdf/" + id,
        formData,
        {
          headers,
          responseType: "blob",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshConsignmentList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public cancelRequisition(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_CANCEL_REQUISION + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  //**================================== Requisition Item =========================*/
  public getAllRequisitionItems(id: any) {
    return this.http
      .get(
        environment.base_url + "/requisition-items/by-requisition-note/" + id,
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createRequisitionItem(body: any) {
    return this.http
      .post(environment.base_url + "/requisition-items", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionItemList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public editRequisitionItem(body: any) {
    return this.http
      .put(environment.base_url + "/requisition-items", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionItemList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getRequisitionItemById(id: any) {
    return this.http
      .get(environment.base_url + "/requisition-items/" + id)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteRequisitionItem(id: any) {
    return this.http
      .delete(environment.base_url + "/requisition-items/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionItemList$.emit("Deleted Requisition Item");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  //**================================== asset History tab =========================*/
  public geAssetHistory(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    assetsId: any | number | boolean,
    columnName: any | number | boolean,
    sortOrder: any | number | boolean,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (columnName) params = params.set("columnName", columnName);
    if (sortOrder) params = params.set("sortOrder", sortOrder);
    if (assetsId) params = params.set("assetsId", assetsId);
    return this.http
      .get(environment.base_url + "/bin-inventory-histories", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  enableButton(data: any) {
    this.refreshButton$.emit(data);
  }

  public getAssetByFilter(assetName: any, siteId: any = null) {
    let params = new HttpParams();
    if (assetName) params = params.set("search", assetName);
    if (siteId) params = params.set("siteId", siteId);
    return this.http
      .get(
        environment.base_url +
          "/v5/assets/filter?startFrom=1&perPage=50&columnName=name&sortOrder=asc",
        { observe: "response", params },
      )
      .pipe(
        map((resp: any) => (resp.status == 204 ? false : resp.body)),
        catchError((error) => throwError(() => error)),
      );
  }

  /**================================== List Of Asset =========================*/
  public getAssetList(
    serviceZoneName: any,
    assetId: any,
    searchValue: any,
    assetTypes: any,
    assetStatuses: any,
    fromDate: any,
    toDate: any,
    parameters: any,
    siteId: any,
    eligibleParentAssets: any,
    eligibleChildAssets: any,
    assetsIgnoreId: any,
    customerId: any = null,
    projectId: any = null,
  ) {
    let params = new HttpParams();
    if (serviceZoneName)
      params = params.set("serviceZoneName", serviceZoneName);
    if (assetId) params = params.set("assetId", assetId);
    if (searchValue) params = params.set("search", searchValue);
    if (siteId) params = params.set("siteId", siteId);
    if (eligibleParentAssets)
      params = params.set("eligibleParentAssets", eligibleParentAssets);
    if (eligibleChildAssets)
      params = params.set("eligibleChildAssets", eligibleChildAssets);
    if (assetsIgnoreId) params = params.set("assetsIgnoreId", assetsIgnoreId);
    if (customerId) params = params.set("customerId", customerId);
    if (projectId) params = params.set("projectId", projectId);
    if (assetTypes) params = params.set("assetTypes", assetTypes);
    if (assetStatuses) params = params.set("assetStatuses", assetStatuses);
    if (fromDate && toDate) {
      fromDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(fromDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      toDate = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(toDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      params = params
        .set("nextMaintenanceFromDateTime", fromDate)
        .set("nextMaintenanceToDateTime", toDate);
    }
    if (parameters)
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "25")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);

    return this.http
      .get(environment.base_url + "/v5/assets/filter", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAllAssets(
    serviceZoneName: any,
    assetId: any,
    customerId: any,
    siteId: any,
    searchValue: any,
    assetTypes: any,
    assetStatuses: any,
    fromDate: any,
    toDate: any,
    origin: any,
    parameters: any,
    pendingTransfer: any,
    projectId: any,
    siteBlockIds?: any,
    siteLevelIds?: any,
    siteBlockAreaIds?: any,
  ) {
    let params = new HttpParams();
    if (serviceZoneName)
      params = params.set("serviceZoneName", serviceZoneName);
    if (assetId) params = params.set("assetId", assetId);
    if (customerId) params = params.set("customerId", customerId);
    if (siteId) params = params.set("siteId", siteId);
    if (projectId) params = params.set("projectId", projectId);
    if (searchValue) params = params.set("search", searchValue);
    if (assetTypes) params = params.set("assetTypes", assetTypes);
    if (assetStatuses) params = params.set("assetStatuses", assetStatuses);
    if (siteBlockIds && siteBlockIds.length)
      params = params.set("siteBlockIds", siteBlockIds);
    if (siteLevelIds && siteLevelIds.length)
      params = params.set("siteLevelIds", siteLevelIds);
    if (siteBlockAreaIds && siteBlockAreaIds.length)
      params = params.set("siteBlockAreaIds", siteBlockAreaIds);
    if (fromDate && toDate) {
      fromDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(fromDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      toDate = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(toDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      params = params
        .set("nextMaintenanceFromDateTime", fromDate)
        .set("nextMaintenanceToDateTime", toDate);
    }
    if (pendingTransfer)
      params = params.set("pendingTransfer", pendingTransfer);
    if (origin && origin !== null && origin !== "")
      params = params.set("origin", origin);

    if (parameters)
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "25")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);

    return this.http
      .get(environment.base_url + "/v5/assets/filter", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }
  public getAssetsByName(search: any, customerId?: any, siteId?: any, projectId?: any) {
    let url =
      environment.base_url +
      "/v5/assets/filter?startFrom=1&perPage=50&search=" +
      search +
      "&columnName=name&sortOrder=asc";
    if (customerId) url += "&customerId=" + customerId;
    if (siteId) url += "&siteId=" + siteId;
    if (projectId) url += "&projectId=" + projectId;
    return this.http
      .get(url)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }


  /******************************************** Search Asset By Customer Id ******************************************/
  public getAssets(custId: any = null, assetName: any = null) {
    let params = new HttpParams();
    if (custId !== "" && custId != null)
      params = params.set("customerId", custId);
    if (assetName !== "" && assetName != null)
      params = params.set("name", assetName);

    return this.http
      .get(`${environment.base_url}/v4/assets/pick-list`, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => (resp.status == 204 ? false : resp.body)),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** delete asset by id ******************************************/
  public deleteAsset(id: any) {
    return this.http
      .delete(environment.base_url + this.ENDPOINT_DELETE_ASSET + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** create asset ******************************************/
  public createAsset(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_SAVE_ASSET_POST, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** edit asset ******************************************/
  public editAsset(
    body: any,
    updateChildAssetsAddress: boolean = false,
    updateChildAssetsCustodian: boolean = false,
    updateChildAssetsCustomer: boolean = false,
    updateChildAssetsServiceZone: boolean = false,
    updateChildAssetsStatus: boolean = false,
  ) {
    let params = new HttpParams();
    params = params.set("updateChildAssetsAddress", updateChildAssetsAddress);
    params = params.set(
      "updateChildAssetsCustodian",
      updateChildAssetsCustodian,
    );
    params = params.set("updateChildAssetsCustomer", updateChildAssetsCustomer);
    params = params.set(
      "updateChildAssetsServiceZone",
      updateChildAssetsServiceZone,
    );
    params = params.set("updateChildAssetsStatus", updateChildAssetsStatus);
    return this.http
      .put(environment.base_url + this.ENDPOINT_SAVE_ASSET_PUT, body, {
        params,
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getListColumn(apiModule: any) {
    return this.http
      .get(
        environment.base_url +
          "/table-column-setups/by-module?apiModule=" +
          apiModule,
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  assetLogData(searchValue: any, parameters: any, apiParams: any) {
    let params = new HttpParams();
    if (searchValue !== "" && searchValue != null) {
      params = params.set("search", searchValue);
    }
    if (apiParams.fromDate)
      params = params.set("fromDateTime", apiParams.fromDate);
    if (apiParams.toDate) params = params.set("toDateTime", apiParams.toDate);
    if (apiParams.assetId) params = params.set("assetId", apiParams.assetId);
    if (apiParams.modifiedBy)
      params = params.set("modifiedBy", apiParams.modifiedBy);

    params = params
      .set("startFrom", parameters.startRow)
      .set("perPage", "25")
      .set("columnName", parameters.sortModel[0].colId)
      .set("sortOrder", parameters.sortModel[0].sort);

    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSETS_LOG, {
        params,
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  getReadingDynamicForm(assetId: any) {
    let params = new HttpParams();
    params = params.set("formSchemaName", "HourMeter");
    params = params.set("parentName", "assets");
    params = params.set("parentId", assetId);

    return this.http
      .get(environment.node_url + "/v1/dynamic-form/schemas/template", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => (resp.status == 204 ? false : resp.body)),
        catchError((error) => throwError(() => error)),
      );
  }

  deleteReadingDynamic(id: any) {
    return this.http
      .delete(environment.node_url + "/v1/dynamic-form/data/HourMeter/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshAssetLogList$.emit("Deleted Reading");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getMaintenanceFrequencyPicklist(maintenanceId: any) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_MAINTENANCE_FREQUENCY_PICKLIST +
          "?maintenanceId=" +
          maintenanceId,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAssetMetersUnitsOfMeasurement() {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_ASSET_METERS_UNITS_OF_MEASUREMENT,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  /////////////////////////////////////////////// accessories //////////////////////////////////
  //grid call(contracts - view - accessories)
  public getContractAccessoriesGrid(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    contractId: any | number | boolean,
    statuses: any | number | boolean,
    parameters: any,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (contractId) params = params.set("contractId", contractId);
    if (statuses) params = params.set("statuses", statuses);
    if (parameters)
      params = params
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    return this.http
      .get(environment.base_url + this.ENDPOINT_CONTRACT_ACCESSORIES, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getContractAssetsGrid(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    contractId: any | number | boolean,
    statuses: any | number | boolean,
    parameters: any,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (contractId) params = params.set("contractId", contractId);
    if (statuses) params = params.set("statuses", statuses);
    if (parameters)
      params = params
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    return this.http
      .get(environment.base_url + this.ENDPOINT_CONTRACT_ASSETS, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getContractMaintenanceById(id: any) {
    return this.http
      .get(environment.base_url + "/contract-maintenances/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  deleteContractMaintenance(id: any) {
    return this.http
      .delete(environment.node_url + "/contract-maintenances/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshAssetLogList$.emit("Deleted Reading");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public createContractMaintenance(body: any) {
    return this.http
      .post(environment.base_url + "/contract-maintenances", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshMaintenanceList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public contractAssets(id: any) {
    return this.http
      .put(
        environment.base_url +
          "/contracts/remove/contract-item?contractItemId=" +
          id,
        null,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshMaintenanceList$.emit("Deleted Contract Assets");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public createAssetLog(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_ASSETS_LOG, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateAssetLog(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_ASSETS_LOG, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAssetsLogModifiedUsers() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSETS_LOG_MODIFIED_USERS)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  deleteAssetLog(id: any) {
    return this.http
      .delete(environment.base_url + this.ENDPOINT_ASSETS_LOG + "/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshAssetLogList$.emit("Deleted Status");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  /** ✅ UPDATED (was @angular/http) */
  public uploadAttachmentV2(parentType: any, formData: any) {
    const headers = this.authHeaders(); // FormData => no Content-Type
    return this.http
      .post(
        environment.base_url + this.ENDPOINT_ATTACHMENTS_UPLOADV2 + parentType,
        formData,
        { headers, observe: "response" },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //grid call(assets - view -Contracts)
  public getPriceBookContractGrid(
    startFrom: any | number | boolean,
    perPage: any | number | boolean,
    search: any | number | boolean,
    priceBookId: any | number | boolean,
    statuses: any | number | boolean,
    parameters: any,
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (priceBookId) params = params.set("priceBookId", priceBookId);
    if (statuses) params = params.set("statuses", statuses);
    if (parameters)
      params = params
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    return this.http
      .get(environment.base_url + this.ENDPOINT_CONTRACTS_ASSETS, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAllAssetsforRequisition(binId: any, filter: any) {
    let params = new HttpParams();
    if (binId) params = params.set("binId", binId);
    if (filter.assetTypes != null && filter.assetTypes != "")
      params = params.set("assetsTypeIds", filter.assetTypes);
    if (filter.assetStatuses != null && filter.assetStatuses != "")
      params = params.set("assetsStatusIds", filter.assetStatuses);
    return this.http
      .get(environment.base_url + "/assets/all", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAllproductforRequisition(
    binId: any,
    filter: any,
    searchValue: any,
  ) {
    let params = new HttpParams();
    if (binId) params = params.set("binId", binId);
    if (filter.productType != null && filter.productType != "")
      params = params.set("typeIds", filter.productType);
    if (filter.productFamilies != null && filter.productFamilies != "")
      params = params.set("familyIds", filter.productFamilies);
    if (searchValue) params = params.set("search", searchValue);
    return this.http
      .get(environment.base_url + "/products/all", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAllCategory() {
    return this.http.get(environment.base_url + "/asset-categories").pipe(
      map((resp: any) => resp),
      catchError((error) => throwError(() => error)),
    );
  }

  public getAllSubCategory(assetCategoryIds: any) {
    let params = new HttpParams();
    params = params.set("isOrder", true);
    if (assetCategoryIds)
      params = params.set("assetCategoryIds", assetCategoryIds);
    return this.http
      .get(environment.base_url + "/asset-sub-categories/picklist", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //**================================== get Analytics =========================*/
  getAnalytics(assetsId: any) {
    return this.http
      .get(environment.base_url + "/assets/calculations/" + assetsId, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //**================================== Save Analytics =========================*/
  public updateAnalytics(body: any) {
    return this.http
      .put(environment.base_url + "/assets/calculations", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  //For managing Asset categories create, update and get
  public createAssetCategory(body: any): Observable<any> {
    return this.http
      .post(environment.base_url + this.ENDPOINT_ASSET_CATEGORIES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshAssetCategoryList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateAssetCategory(body: any): Observable<any> {
    return this.http
      .put(environment.base_url + this.ENDPOINT_ASSET_CATEGORIES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshAssetCategoryList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAssetCategoryById(id: any): Observable<any> {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSET_CATEGORIES + "/" + id)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteAssetCategory(id: any): Observable<any> {
    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_ASSET_CATEGORIES + "/" + id,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshAssetCategoryList$.emit("Deleted Asset Category");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  //For managing asset sub-categories get, create,update, delete
  public getAllAssetSubCategories(): Observable<any> {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSET_SUB_CATEGORIES)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAssetSubCategoryById(id: any): Observable<any> {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSET_SUB_CATEGORIES + "/" + id)
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createAssetSubCategory(body: any): Observable<any> {
    return this.http
      .post(environment.base_url + this.ENDPOINT_ASSET_SUB_CATEGORIES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshAssetSubCategoryList$.emit("Created Asset Sub-Category");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateAssetSubCategory(body: any): Observable<any> {
    return this.http
      .put(environment.base_url + this.ENDPOINT_ASSET_SUB_CATEGORIES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshAssetSubCategoryList$.emit("Updated Asset Sub-Category");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public deleteAssetSubCategory(id: any): Observable<any> {
    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_ASSET_SUB_CATEGORIES + "/" + id,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshAssetSubCategoryList$.emit("Deleted Asset Sub-Category");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  // For Asset Attachment
  public getAttachmentsByAssetId(assetId: any): Observable<any> {
    let params = new HttpParams();
    params = params.set("parentId", assetId);
    params = params.set("parentType", "ASSET_ATTACHMENT");

    return this.http
      .get(environment.base_url + this.ENDPOINT_GET_ATTACHMENTS_BY_PARENT, {
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /** ✅ UPDATED (was @angular/http) */
  public uploadAttachmentByAssetId(assetId: any, formData: any) {
    const headers = this.authHeaders(); // FormData => no Content-Type
    return this.http
      .post(
        environment.base_url + this.ENDPOINT_UPLOAD_ASSET_ATTACHMENTS + assetId,
        formData,
        {
          headers,
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refreshPhoto$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getAllAssetsComponent(
    searchValue: any,
    origin: any,
    assetsParentId: any,
    parameters: any,
  ) {
    let params = new HttpParams();
    if (assetsParentId) params = params.set("assetsParentId", assetsParentId);
    if (searchValue) params = params.set("search", searchValue);
    if (origin && origin !== null && origin !== "")
      params = params.set("origin", origin);

    if (parameters)
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "25")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);

    return this.http
      .get(environment.base_url + "/v5/assets/filter", {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** create asset Component ******************************************/
  public createAssetComponent(body: any) {
    return this.http
      .put(environment.base_url + "/assets/add-child-assets", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshComponentList$.emit("Created Asset Component");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  /******************************************** Delete Component ******************************************/
  public deleteComponent(body: any): Observable<any> {
    return this.http
      .put(environment.base_url + "/assets/remove-child-assets", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshComponentList$.emit("Deleted Asset Component");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }
  getEncryptedTenantId(tenantId: any) {
    return this.http
      .get(
        environment.base_url + "/open/tenant-id/encrypt?tenantId=" + tenantId,
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  /******************************************** Asset Details Overview ******************************************/
  public getAssetDetailsOverview(assetsId: any) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_ASSETS_DETAIL_OVERVIEW + assetsId,
        { observe: "response" },
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  /****** Asset Type new version (PM3 addon) API starts here ********/
  public getAssetStatusCategories() {
    //Asset Type GET status category api
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSET_STATUSES_GROUP, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createAssetStatus(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_ASSET_STATUSES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getStatusesNew(active: any = null) {
    var active1 = "";
    if (active) {
      active1 = "?isActive=true";
    }
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSETS_STATUSES_NEW + active1, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getStatusesByAssetType(assetTypeId: string) {
    //this is used in asset detail view page
    //v4/assets-statuses?assetsTypeId=1&isActive=true
    let url: string = environment.base_url + this.ENDPOINT_ASSETS_STATUSES_NEW;
    if (assetTypeId) {
      url = url + "?assetsTypeId=" + assetTypeId + "&isActive=true";
    }
    return this.http
      .get(url, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createAssets(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_ASSETS, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getStatusByAssetType(assetTypeId: string) {
    //this is used in set up asset type detail page
    let url: string = environment.base_url + this.ENDPOINT_ASSETS_BY_TYPEID;
    if (assetTypeId) {
      url = url + "?assetTypeId=" + assetTypeId;
    }
    return this.http
      .get(url, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getStatusByIdV2(statusId: string) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_ASSET_STATUSES + "/" + statusId,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateAssetStatus(body: any, statusId: string) {
    return this.http
      .put(
        environment.base_url + this.ENDPOINT_ASSET_STATUSES + "/" + statusId,
        body,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateAssetType(body: any, typeId: string) {
    return this.http
      .put(environment.base_url + "/assets-types/status-info/" + typeId, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateAssetTypeOrder(body: any) {
    return this.http
      .put(environment.base_url + "/assets-types/order-update", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }
  public getMeterTypes() {
    return this.http
      .get(environment.base_url + "/asset-meters-units-of-measurement", {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }
  public updateMeterSetting(body: any, typeId: string) {
    return this.http
      .put(environment.base_url + "/assets-types/meter-info/" + typeId, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public reorderAssetStatuses(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_ASSETS_STATUS_REORDER, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getCertTypesByAssetType(
    assetsTypeId: any,
    search: any,
    parameters: any,
  ) {
    //{{ip}}/api/asset-certification-types/asset-type/{{assetsTypeId}}?
    //page=1&perPage=10&startFrom=1&columnName=id&sortOrder=desc

    let params: any = new HttpParams();
    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", parameters.perPage)
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    if (search !== "" && search != null) {
      params = params.set("search", search);
    }

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSET_CERT_TYPES +
          "/asset-type/" +
          assetsTypeId,
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public createAssetCertType(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_ASSET_CERT_TYPES+"?propagate=true", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public updateAssetCertType(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_ASSET_CERT_TYPES+"?propagate=true", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }
  public deleteCertType(id: any) {
    return this.http.delete(
        environment.base_url + this.ENDPOINT_ASSET_CERT_TYPES + "/" + id,
        {
          observe: "response"
        }
      )
      .pipe(
        map((resp: any) => {
          this.refresherCertTypeList$.emit("Deleted Cert Type");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public createAssetInspectionType(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_ASSET_INSPECT_TYPES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }
  public deleteInspectionType(id: any) {
    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_ASSET_INSPECT_TYPES + "/" + id,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          this.refresherInspectTypeList$.emit("Deleted Inspection Type");
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getInspectionTypesByAssetType(
    assetsTypeId: any,
    search: any,
    parameters: any,
  ) {
    //{{ip}}/api/asset-certification-types/asset-type/{{assetsTypeId}}?
    //page=1&perPage=10&startFrom=1&columnName=id&sortOrder=desc

    let params: any = new HttpParams();
    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", parameters.perPage)
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    if (search !== "" && search != null) {
      params = params.set("search", search);
    }

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSET_INSPECT_TYPES +
          "/asset-type/" +
          assetsTypeId,
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }
  public updateAssetInspectionType(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_ASSET_INSPECT_TYPES, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getChecklistByAssetTypeId(assetsTypeId: any) {
    return this.http
      .get(
        environment.base_url +
          `/tmpl-checklists/picklist?assetsTypeId=${assetsTypeId}`,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getCertTypesByAsset(assetId: any, search: any, parameters: any) {
    //https://dev-api.fieldex.com/custella-0.0.1-SNAPSHOT/api/asset-certification-types/asset/226?page=1&perPage=10&startFrom=1&columnName=id&sortOrder=desc

    let params: any = new HttpParams();
    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "25")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    if (search !== "" && search != null) {
      params = params.set("search", search);
    }

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSET_CERT_TYPES +
          "/asset/" +
          assetId,
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getCertTypesByAssetLatestRecords(
    assetId: any,
    search: any,
    parameters: any,
  ) {
    let params: any = new HttpParams();
    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "100")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    if (search !== "" && search != null) {
      params = params.set("search", search);
    }

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSET_CERT_TYPES +
          "/asset/" +
          assetId +
          "/with-latest-records",
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getCertRecordsByAssetId(assetId: any, search: any, parameters: any) {
    //{{ip}}/api/asset-certification-records/asset/{{assetId}}?search=mag
    let params: any = new HttpParams();
    if (parameters) {
      params = params
        //.set("startFrom", parameters.startRow)
        .set("perPage", parameters.perPage)
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    if (parameters.page) {
      params = params.set("page", parameters.page);
    }

    if (parameters && parameters.status != "") {
      params = params.set("status", parameters.status);
    }

    if (search !== "" && search != null) {
      params = params.set("search", search);
    }

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSET_CERT_RECORDS +
          "/asset/" +
          assetId,
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getCertRecordsByCertTypeId(
    certTypeId: any,
    search: any,
    parameters: any,
  ) {
    let params: any = new HttpParams();
    if (parameters) {
      params = params
        //.set("startFrom", parameters.startRow)
        .set("perPage", parameters.perPage)
        .set("page", parameters.page)
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    if (search !== "" && search != null) {
      params = params.set("search", search);
    }

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSET_CERT_RECORDS +
          "/certification-type/" +
          certTypeId,
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public markCertComplete(payload: any) {
    return this.http
      .post(
        environment.base_url +
          this.ENDPOINT_ASSET_CERT_RECORDS +
          "/complete-multipart",
        payload,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getCertRecordById(certId: any) {
    return this.http
      .get(
        environment.base_url + this.ENDPOINT_ASSET_CERT_RECORDS + "/" + certId,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  /*inspection related api starts here*/
  public getInspectionTypesByAssetLatestRecords(
    assetId: any,
    search: any,
    parameters: any,
  ) {
    let params: any = new HttpParams();
    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "100")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    if (search !== "" && search != null) {
      params = params.set("search", search);
    }

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSET_INSPECT_TYPES +
          "/asset/" +
          assetId +
          "/with-latest-records",
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getChecklistByAssetId(assetsId: any) {
    return this.http
      .get(
        environment.base_url + `/tmpl-checklists/picklist?assetId=${assetsId}`,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getInspectRecordsByAssetId(
    assetId: any,
    search: any,
    parameters: any,
  ) {
    let params: any = new HttpParams();
    if (parameters) {
      params = params
        //.set("startFrom", parameters.startRow)
        .set("perPage", parameters.perPage)
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    if (parameters.page) {
      params = params.set("page", parameters.page);
    }

    if (parameters && parameters.status != "") {
      params = params.set("status", parameters.status);
    }

    if (search !== "" && search != null) {
      params = params.set("search", search);
    }

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSET_INSPECT_RECORDS +
          "/asset/" +
          assetId,
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getInspectionRecordsByInspectionTypeId(
    inspectTypeId: any,
    search: any,
    parameters: any,
  ) {
    //asset-inspection-records/inspection-type/
    let params: any = new HttpParams();
    if (parameters) {
      params = params
        //.set("startFrom", parameters.startRow)
        .set("perPage", parameters.perPage)
        .set("page", parameters.page)
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);
    }

    if (search !== "" && search != null) {
      params = params.set("search", search);
    }

    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSET_INSPECT_RECORDS +
          "/inspection-type/" +
          inspectTypeId,
        {
          observe: "response",
          params,
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public getInspectionRecordById(inspectId: any) {
    return this.http
      .get(
        environment.base_url +
          this.ENDPOINT_ASSET_INSPECT_RECORDS +
          "/" +
          inspectId,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }

  public markInspectionComplete(payload: any) {
    return this.http
      .post(
        environment.base_url +
          this.ENDPOINT_ASSET_INSPECT_RECORDS +
          "/complete-multipart",
        payload,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }

  public getValidateComponent(statusId: any, id: any) {
    let apiUrl: string = this.ENDPOINT_VALIDATE_COMPONENT + "?statusId=" +statusId + "&id=" +id;
    return this.http
      .get(environment.base_url + apiUrl, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }


  public generateInspectionChecklist(inspectionRecordId: any, payload: any) {
    return this.http
      .post(
        environment.base_url + this.ENDPOINT_ASSET_INSPECT_RECORDS + "/" + inspectionRecordId + "/generate-checklist",
        payload,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error)),
      );
  }
}
// ## Summary of changes:

// 1. ✅ **Removed deprecated imports:**
//    - Removed all imports from `@angular/http`: `Http`, `RequestOptions`, `Headers`, `ResponseContentType`
//    - Removed `private httpOnly: Http` parameter

// 3. ✅ **Updated multiple upload methods:**
//    - `uploadAttachment()` - Changed to use `HttpHeaders` and `HttpClient`
//    - `uploadAttachmentV2()` - Changed to use `HttpHeaders` and `HttpClient`
//    - `uploadConsignmentAttachment()` - Changed to use `HttpHeaders` and `HttpClient`
//    - `uploadRequisitionAttachment()` - Changed to use `HttpHeaders` and `HttpClient`
//    - `uploadAttachmentByAssetId()` - Changed to use `HttpHeaders` and `HttpClient`

// 4. ✅ **Updated PDF generation methods:**
//    - `generateConsignmentPDF()` - Changed to use `HttpClient` with proper blob response type
//    - `generateRequisitionPDF()` - Changed to use `HttpClient` with proper blob response type

// All methods have been updated to use the modern `HttpClient` API. The code should now compile successfully with Angular 19!